<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px; padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.groupName"
              placeholder="微信群名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.nickname"
              placeholder="成员昵称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.storeName"
              placeholder="门店名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.storePhone"
              placeholder="门店联系电话"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <date-select :search-date.sync="masterList.tableQuery.searchDate" />
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px; padding: 0 2px;"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @export="batchExport(masterList)"
      />
    </div>
    <!--
      @view="handleView(arguments)"
      @dblclick="handleView(arguments)"
    -->

    <!-- 查看 -->
    <!-- <view-dialog
      :data-id="id"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogViewVisible"
      @reloadData="loadTableData()"
    /> -->
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 日期选择
import DateSelect from '@/components/DateSelect';
// 查看
// import viewDialog from './components/viewDialog'
// 微信群消息管理API
import { loadWeChatGroupMessageListDataApi, exportWeChatGroupMessageListDataApi } from '@/api/v2/weChatGroupMessage'

export default {
  name: 'WeChatGroupMessageView',
  components: { CustomTable2, TableOperation2, DateSelect, },
  // viewDialog
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'chat_room_message_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          // {
          //   permissionSigns: ['chat_room_message_view'],
          //   prop: 'view',
          //   label: '查看',
          //   method: 'view'
          // },
          {
            permissionSigns: ['chat_room_message_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          groupName: '',
          nickname: '',
          storeName: '',
          storePhone: '',
          searchDate: 'month'
        },
      },
      id: null,
      dialogViewVisible: false,
      dialogTitle: '',
      eventType: '',
      msgTypeSql: "(case when msg.type = 1 then '文本' when msg.type = 3 then '图片' when msg.type = 34 then '语音' when msg.type = 43 then '视频' when msg.type = 47 then '动画表情' when msg.type = 49 and sub_type = 1 then '特殊文本消息' when msg.type = 49 and sub_type = 5 then '卡片式链接' when msg.type = 49 and sub_type = 6 then '文件' when msg.type = 49 and sub_type = 8 then 'GIF表情' when msg.type = 49 and sub_type = 19 then '合并转发聊天记录' when msg.type = 49 and (sub_type = 33 or sub_type = 36) then '小程序分享' when msg.type = 49 and sub_type = 57 then '引用消息' when msg.type = 49 and (sub_type = 63 or sub_type = 88) then '视频号直播' when msg.type = 49 and sub_type = 87 then '群公告' when msg.type = 49 and sub_type = 2000 then '转账消息' when msg.type = 49 and sub_type = 2003 then '红包' else '其他类型' end)",
    }
  },
  created () {
    let _this = this;
    // 初始化主列表Table列
    _this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80, align: 'center' },
      { prop: 'groupName', label: '微信群', filterColumn: 'twcg.name', width: 150 },
      { prop: 'userWxId', label: '微信ID', filterColumn: 'twcc.user_name', width: 150 },
      { prop: 'nickname', label: '昵称', filterColumn: 'twcc.nickname', width: 150 },
      { prop: 'groupNickname', label: '群昵称', filterColumn: 'twcgm.user_remark', width: 150 },
      { prop: 'typeValue', label: '消息类型', filterColumn: _this.msgTypeSql, width: 110 },
      { prop: 'contentValue', label: '消息内容', filterColumn: "if(msg.type = 1, msg.content, " + _this.msgTypeSql + ")", width: 240 },
      { prop: 'archiveStoreName', label: '门店名称(零售户)', filterColumn: "IFNULL(tsi.store_name, '')", width: 150 },
      { prop: 'archiveCertificateNo', label: '专卖证号(零售户)', filterColumn: "IFNULL(tsi.certificate_no, '')", width: 150 },
      { prop: 'archiveBxCode', label: '本香门店码(零售户)', filterColumn: "IFNULL(tsi.benxiang_store_no, '')", width: 160 },
      { prop: 'archivePhone', label: '联系电话(零售户)', filterColumn: "IFNULL(tsi.phone, '')", width: 150 },
      { prop: 'createTime', label: '消息创建时间', filterColumn: 'FROM_UNIXTIME(msg.create_time)', width: 150, isBetween: true },
    ]
    // 默认主列表Table列
    _this.getInitTableColumns()
    _this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      loadWeChatGroupMessageListDataApi(_this.masterList.tableQuery).then(response => {
        const { data } = response;
        _this.handleData(data.list || [])
        _this.masterList.tableDataTotal = data.total || 0
      }).catch()
    },
    // 查看
    handleView (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要查看的微信群成员', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.dialogTitle = '查看微信群成员信息'
      _this.dialogViewVisible = !_this.dialogViewVisible
    },
    // 导出数据API
    exportByPage () {
      let _this = this;
      exportWeChatGroupMessageListDataApi(_this.exportObj).then((response) => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
